module.exports = __webpack_public_path__ + "static/ecomi-63f3350895d8b97dfae82c4d9ff07ee3.jpg";